import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import locales from "../../../locales";
import { DEFAULT_LANGUAGE, DEFAULT_REGION } from "../../../utils/locale.utils";

export const mapStateToProps = (state) => {
  const defaultLocale = { language: DEFAULT_LANGUAGE, region: DEFAULT_REGION };
  const localeFromState = formatLocale(state.locale);
  const locale =
    state.locale.availableLocales.indexOf(localeFromState) > -1
      ? localeFromState
      : formatLocale(defaultLocale);
  return {
    locale,
    messages: locales[locale],
  };
};

export default connect(mapStateToProps)(IntlProvider);

function formatLocale({ language, region }) {
  if (region) {
    return `${language}-${region.toUpperCase()}`;
  }

  return language;
}
